import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6">
            <img src="img/NewLogoSobre2.jpg" className="img-fluid" alt="" />
          </div>
          <div className="col-12 col-md-6">
            <div className="about-text">
              <h2 className="text-center text-md-start">Sobre</h2>
              <p className="white-space-pre-line">{props.data ? props.data.paragraph : "loading..."}</p>
              <h3 className="section-title text-center mt-3">Porque nos escolher?</h3>
              <div className="list-style-alt row">
                <div className="col-6">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                        <li key={`${d}-${i}`}>{d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-6">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                        <li key={`${d}-${i}`}>{d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
